module.exports = __webpack_public_path__ + "img/img-part-2-mainimg.d6855abf.png";